import React, { useEffect, useState } from "react";
import "./RecentPost.css";
import SimpleRecentPost from "./SimpleRecentPost";

const RecentPost = () => {
    const [allblog, setBlog] = useState([]);
    const [loading, setloading] = useState([true]);

    //fetch  Serverblog
    const url = "https://coderchefserver.herokuapp.com/blog";
    useEffect(() => {
        fetch(url)
            .then((res) => res.json())
            .then((blog) => {
                setBlog(blog.slice(-5).reverse());
                setloading(false);
            });
    }, []);
    return (
        <div className="recentpost_area">
            <div className="right_text">
                <h3>RECENT POSTS</h3>
            </div>
            {loading ? (
                <div className="text-center mt_30 mb_30">
                    <div className="spinner-border text-warning" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                allblog.map((e) => (
                    <SimpleRecentPost key={e._id} blog={e}></SimpleRecentPost>
                ))
            )}
        </div>
    );
};

export default RecentPost;
